var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sys-select-base", {
        attrs: {
          model: _vm.selected,
          items: _vm.items,
          loading: _vm.loading,
          label: _vm.label,
          error: _vm.error,
          errors: _vm.errors,
          clearable: _vm.clearable,
          dense: _vm.dense,
          multiple: _vm.multiple,
          showAdd: _vm.showAdd,
          disabled: _vm.disabled,
        },
        on: {
          "update:model": function ($event) {
            _vm.selected = $event
          },
          onShowForm: function ($event) {
            _vm.showForm = true
          },
        },
        scopedSlots: _vm._u(
          [
            _vm.$scopedSlots["append-extra"]
              ? {
                  key: "append-extra",
                  fn: function () {
                    return [_vm._t("append-extra")]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }